export type BillingsOrderForwardTaxiTaxiRecalculateRequestNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionBonusFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionBonusOther =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyOther =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionBonus =
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionBonusFavorableDistance
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionBonusOther;

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenalty =
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyWrongRoute
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyBeingLate
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyIncompatibleCar
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenaltyOther;

export type BillingsOrderForwardTaxiTaxiRecalculateRequestContribution =
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionBonus
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionPenalty;

export type BillingsOrderForwardTaxiTaxiRecalculateRequestBody = {
  billingNodes: BillingsOrderForwardTaxiTaxiRecalculateRequestNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiRecalculateRequestContribution[];
};

type BillingsOrderForwardTaxiTaxiRecalculateRequest = {
  orderForwardingUuid: string;
  billingNodes: BillingsOrderForwardTaxiTaxiRecalculateRequestNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiRecalculateRequestContribution[];
};

export default BillingsOrderForwardTaxiTaxiRecalculateRequest;
